module.exports = __webpack_public_path__ + "static/media/SL.338d9d77.svg";